/*
 * Prompt Library API Routes
 * Features: CRUD operations for user prompt templates
 * Logic: RESTful endpoints calling stored procedures for prompt management
 * Changes: 
 * - Initial implementation with filtering and usage tracking
 * - Fixed optional parameters: use .nullable().default(null) instead of .optional() to ensure null values are passed to SQL
 */

import { z } from "zod";
import { DataRoutes } from "./types";

const promptRoutes: DataRoutes = {
  // Get all prompts for current user with optional filters
  'get /api/data/prompts': {
    schema: z.object({
      category: z.string().nullable().default(null),
      favoritesOnly: z.boolean().default(false),
      searchTerm: z.string().nullable().default(null),
    }),
    query: `EXEC [dbo].[GetPrompts] 
      @Category = @category, 
      @IncludeFavoritesOnly = @favoritesOnly, 
      @SearchTerm = @searchTerm`
  },

  // Get specific prompt by ID
  'get /api/data/prompts/:id': {
    schema: z.object({
      id: z.number().int(),
    }),
    query: `SELECT * FROM [dbo].[PromptLibrary] WHERE Id = @id`
  },

  // Create new prompt
  'post /api/data/prompts': {
    schema: z.object({
      promptContent: z.string(),
    }),
    query: `EXEC [dbo].[InsertPrompt] 
      @PromptContent = @promptContent`
  },

  // Update existing prompt
  'put /api/data/prompts/:id': {
    schema: z.object({
      id: z.number().int(),
      title: z.string().optional(),
      description: z.string().optional(),
      promptContent: z.string().optional(),
      category: z.string().optional(),
      tags: z.string().optional(),
      isFavorite: z.boolean().optional(),
    }),
    query: `EXEC [dbo].[UpdatePrompt] 
      @PromptId = @id,
      @Title = @title,
      @Description = @description,
      @PromptContent = @promptContent,
      @Category = @category,
      @Tags = @tags,
      @IsFavorite = @isFavorite`
  },

  // Delete prompt
  'delete /api/data/prompts/:id': {
    schema: z.object({
      id: z.number().int(),
    }),
    query: `EXEC [dbo].[DeletePrompt] @PromptId = @id`
  },

  // Increment prompt use count
  'post /api/data/prompts/:id/use': {
    schema: z.object({
      id: z.number().int(),
    }),
    query: `EXEC [dbo].[IncrementPromptUseCount] @PromptId = @id`
  },
};

export default promptRoutes;
